export default __webpack_public_path__ + "static/media/voicemail-templates-empty.2f47c18a.svg";